import { useQueryClient } from '@tanstack/react-query';
import { Entity, type Privacy } from 'models';
import { useMutation } from 'query';
import { changeRequest } from 'common/services';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { getChannelsFeatureQueryKey } from 'features/channels/queries/keys';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { getNodeOrganizationsInfiniteQueryKey } from 'features/organizations/queries/keys';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { getProfileQueryKey } from 'features/users/queries/keys';
import { joinCommunity } from '../../services';
import { getCommunitiesInfiniteQueryKey, getCommunityQueryKey } from '../keys';

// TODO should not invalidate all communities, make invalidate correct ones (List type / Detail)
export const useJoinCommunity = () => {
  const queryClient = useQueryClient();

  return useMutation<Entity, { id: string; privacy: Privacy; reason?: string }>({
    async mutationFn({ id, privacy, reason }) {
      // TODO probably ideally in future these 2 seperated mutations
      /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */

      const communityResponse =
        privacy === 'public'
          ? await joinCommunity({ id, reason })
          : await changeRequest({
              kind: 'community_request_to_join',
              meta: {
                reason_to_join: reason,
              },
              subject_id: id,
              subject_type: 'Community',
            });

      /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */

      return new Entity(communityResponse.data);
    },
    async onError() {
      await queryClient.invalidateQueries({ queryKey: getCommunityQueryKey({}) });
      // TODO this will be removed with useCommunityDataObjectQuery
      await queryClient.invalidateQueries({ queryKey: ['data-object', ...getCommunityQueryKey({})] });
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getCommunityQueryKey({}) });
      // TODO this will be removed with useCommunityDataObjectQuery
      await queryClient.invalidateQueries({ queryKey: ['data-object', ...getCommunityQueryKey({})] });
      await queryClient.invalidateQueries({ queryKey: getCommunitiesInfiniteQueryKey({}) });
      await queryClient.invalidateQueries({ queryKey: getChannelsFeatureQueryKey() });
      await queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
      await queryClient.invalidateQueries({ queryKey: getNodeOrganizationsInfiniteQueryKey({}) });
    },
  });
};
